import { del, get, post, put } from "./api_helper";
import * as url from "./url_helper";

export const login = ({ email, password }) => {
  return  post(url.POST_LOGIN, { email, password })
};